import { render, staticRenderFns } from "./ds-toolbar.vue?vue&type=template&id=1bd967df&scoped=true"
import script from "./ds-toolbar.vue?vue&type=script&lang=js"
export * from "./ds-toolbar.vue?vue&type=script&lang=js"
import style0 from "./ds-toolbar.vue?vue&type=style&index=0&id=1bd967df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd967df",
  null
  
)

export default component.exports